import APIService from '../services/api';
import React, { useState } from 'react';
import { X, Download } from 'lucide-react';
import logoDefaut from '../assets/logo-defaut.png';
const BASE = 'https://besoins-tat-production.up.railway.app';

const buildJDPdf = async ({ titre, client, responsable, dateReception, contenu }) => {
  const { jsPDF } = await import('jspdf');
  const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
  const pageW = 210, pageH = 297, marginL = 20, marginR = 20;
  const contentW = pageW - marginL - marginR;
  const red = [192,0,0], dark = [51,51,51], gray = [120,120,120];
  const teal = [0,160,145], white = [255,255,255], lightGray = [245,245,245];

  const addPageFooter = () => {
    doc.setDrawColor(teal[0],teal[1],teal[2]); doc.setLineWidth(0.3);
    doc.line(marginL, pageH-14, pageW-marginR, pageH-14);
    doc.setFont('helvetica','normal'); doc.setFontSize(8);
    doc.setTextColor(gray[0],gray[1],gray[2]);
    doc.text('Document confidentiel', pageW/2, pageH-8, {align:'center'});
  };

  // Logo en tête : celui de l'organisation, sinon la marque neutre embarquée.
  // Le 404 de /config/logo est normal (organisation sans logo personnalisé).
  try {
    let logoBlob = null;
    try {
      // Un fetch porte l'en-tête : rien à mettre dans l'adresse (28.09).
      const r = await fetch(`${BASE}/config/logo`, { headers: { Authorization: `Bearer ${APIService.getToken() || ''}` } });
      if (r.ok) logoBlob = await r.blob();
    } catch (e) { /* hors ligne : on passe au logo par défaut */ }
    const perso = !!logoBlob;
    if (!logoBlob) logoBlob = await (await fetch(logoDefaut)).blob();
    const dataUrl = await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(logoBlob);
    });
    const fmt = /png/i.test(logoBlob.type) ? 'PNG' : 'JPEG';
    if (perso) {
      // Bandeau large : format habituel d'un logo d'entreprise.
      doc.addImage(dataUrl, fmt, pageW/2-27.5, 6, 55, 14.7);
    } else {
      // Marque neutre : carrée, suivie du nom de l'organisation.
      doc.addImage(dataUrl, fmt, pageW/2-7, 5, 14, 14);
      doc.setFont('helvetica','bold'); doc.setFontSize(12);
      doc.setTextColor(dark[0],dark[1],dark[2]);
      doc.text(APIService.getOrgName(), pageW/2, 25, {align:'center'});
    }
  } catch(e) {
    // Ni logo d'organisation, ni asset lisible : le nom suffit.
    doc.setFont('helvetica','bold'); doc.setFontSize(22);
    doc.setTextColor(red[0],red[1],red[2]);
    doc.text(APIService.getOrgName(), pageW/2, 18, {align:'center'});
  }

  let y = 34;
  doc.setFont('helvetica','bold'); doc.setFontSize(18); doc.setTextColor(red[0],red[1],red[2]);
  doc.splitTextToSize(titre||'Poste à pourvoir',contentW).forEach(l => { doc.text(l,pageW/2,y,{align:'center'}); y+=8; });
  y+=4;

  const tableData = [['Intitulé du poste',titre||''], responsable?['Responsable commercial',responsable]:null, dateReception?['Date de réception',dateReception]:null].filter(Boolean);
  const rowH=8, col1W=65;
  doc.setFillColor(red[0],red[1],red[2]); doc.rect(marginL,y,contentW,0.5,'F'); y+=1;

  tableData.forEach((row,i) => {
    const bg = i%2===0 ? lightGray : white;
    doc.setFillColor(bg[0],bg[1],bg[2]); doc.rect(marginL,y,contentW,rowH,'F');
    doc.setFont('helvetica','bold'); doc.setFontSize(9); doc.setTextColor(red[0],red[1],red[2]); doc.text(row[0],marginL+3,y+5.5);
    doc.setFont('helvetica','normal'); doc.setTextColor(dark[0],dark[1],dark[2]);
    doc.text(doc.splitTextToSize(row[1],contentW-col1W-4)[0],marginL+col1W+3,y+5.5);
    doc.setDrawColor(220,220,220); doc.setLineWidth(0.2); doc.line(marginL,y+rowH,marginL+contentW,y+rowH);
    y+=rowH;
  });

  doc.setDrawColor(red[0],red[1],red[2]); doc.setLineWidth(0.5); doc.line(marginL,y,marginL+contentW,y); y+=10;
  doc.setFont('helvetica','normal'); doc.setFontSize(10); doc.setTextColor(dark[0],dark[1],dark[2]);
  const lineHeight=5.5, maxY=pageH-22;
  let pageCount=1;
  const addPage = () => { addPageFooter(); doc.addPage(); pageCount++; y=20; };

  for (const rawLine of contenu.split('\n')) {
    if (!rawLine.trim()) { y+=3; continue; }
    const trimmed = rawLine.trim();
    const isSection =
      trimmed.startsWith('##') ||
      (trimmed === trimmed.toUpperCase() && trimmed.length > 3 && trimmed.length < 80 && /[A-Z]/.test(trimmed)) ||
      (trimmed.endsWith(' :') && trimmed.length < 60 && !trimmed.startsWith('-') && !trimmed.startsWith('•')) ||
      (trimmed.endsWith(':') && trimmed.length < 50 && !trimmed.startsWith('-') && !trimmed.startsWith('•') && !/^\d/.test(trimmed));
    if (isSection) {
      y+=5; if(y+16>maxY) addPage();
      doc.setFont('helvetica','bold'); doc.setFontSize(11); doc.setTextColor(red[0],red[1],red[2]);
      doc.text(rawLine.replace(/^##\s*/,'').trim(),marginL,y); y+=2;
      doc.setDrawColor(red[0],red[1],red[2]); doc.setLineWidth(0.5); doc.line(marginL,y+1,marginL+contentW,y+1);
      doc.setFont('helvetica','normal'); doc.setFontSize(10); doc.setTextColor(dark[0],dark[1],dark[2]); y+=8; continue;
    }
    const isBullet = /^\s*[-•*]/.test(rawLine);
    const text = isBullet ? rawLine.replace(/^\s*[-•*]\s*/,'') : rawLine;
    if (isBullet) { if(y+lineHeight>maxY) addPage(); doc.setFillColor(dark[0],dark[1],dark[2]); doc.circle(marginL+2,y-1.5,1,'F'); }
    for (const wLine of doc.splitTextToSize(text, isBullet ? contentW-6 : contentW)) {
      if(y+lineHeight>maxY) addPage();
      doc.text(wLine, isBullet ? marginL+6 : marginL, y); y+=lineHeight;
    }
    if (isBullet) y+=1;
  }

  const total = doc.internal.getNumberOfPages();
  for (let p=1;p<=total;p++) { doc.setPage(p); addPageFooter(); }

  const filename = APIService.getOrgName('Societe').replace(/[^A-Za-z0-9]+/g,'_')+'_JD_'+(titre||'besoin').replace(/\s+/g,'_')+'_'+new Date().toISOString().slice(0,10)+'.pdf';
  return { blob: doc.output('blob'), filename };
};

const JDGeneratorModal = ({ onClose, showNotification, initialData = {} }) => {
  const [formData, setFormData] = useState({
    titre: initialData.titre || '',
    client: initialData.client || '',
    responsable: initialData.responsable || '',
    dateReception: new Date().toLocaleDateString('fr-FR'),
    contenu: initialData.contenu || ''
  });
  const [generating, setGenerating] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);

  const getToken = () => localStorage.getItem('token') || sessionStorage.getItem('token') || '';

  const handleDownload = async () => {
    if (!formData.contenu.trim()) { showNotification('Collez le contenu du besoin','error'); return; }
    setGenerating(true);
    try {
      const { blob, filename } = await buildJDPdf(formData);
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a'); a.href=url; a.download=filename; a.click();
      URL.revokeObjectURL(url);
      showNotification('PDF téléchargé !','success');
    } catch { showNotification('Erreur génération PDF','error'); }
    finally { setGenerating(false); }
  };

  const handleUploadAndShare = async () => {
    if (!formData.contenu.trim()) { showNotification('Collez le contenu du besoin','error'); return; }
    setUploading(true);
    try {
      const { blob, filename } = await buildJDPdf(formData);

      // Téléchargement local aussi
      const localUrl = URL.createObjectURL(blob);
      const a = document.createElement('a'); a.href=localUrl; a.download=filename; a.click();
      URL.revokeObjectURL(localUrl);

      // Upload base64 → backend → Cloudinary
      const base64 = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result.split(',')[1]);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });

      const res = await fetch(`${BASE}/pieces/upload-jd`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${getToken()}` },
        body: JSON.stringify({ base64, filename })
      });
      const data = await res.json();
      if (data.success && data.url) {
        setPdfUrl(data.url);
        showNotification('PDF hébergé — liens de partage prêts !','success');
      } else {
        showNotification('PDF téléchargé localement (hébergement échoué)','error');
      }
    } catch(e) {
      console.error(e);
      showNotification('Erreur upload','error');
    } finally { setUploading(false); }
  };

  const shareWhatsApp = () => {
    const text = `Fiche de poste ${APIService.getOrgName()} : *${formData.titre}*${formData.client ? ` — ${formData.client}` : ''}\n\nFiche de poste :\n${pdfUrl}\n\nContact : admin@talentaccess.ch`;
    window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, '_blank');
  };

  const shareEmail = () => {
    const subject = encodeURIComponent(`Fiche de poste ${APIService.getOrgName()} : ${formData.titre}${formData.client ? ` — ${formData.client}` : ''}`);
    const body = encodeURIComponent(
      `Bonjour,\n\n` +
      `Veuillez trouver ci-dessous la fiche de poste :\n\n` +
      `Poste : ${formData.titre}\n` +
      `Client : ${formData.client || 'N/A'}\n` +
      `Date : ${formData.dateReception}\n\n` +
      `Télécharger la fiche de poste :\n` +
      `${pdfUrl}\n\n` +
      `Cordialement,\n` +
      `${formData.responsable || APIService.getOrgName()}\n` +
      `Talent Access Technologies\n` +
      `admin@talentaccess.ch`
    );
    window.open(`mailto:?subject=${subject}&body=${body}`, '_blank');
  };

  const f = (label, key, placeholder) => (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>
      <input type="text" value={formData[key]} onChange={e => setFormData({...formData,[key]:e.target.value})}
        className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-indigo-500 text-sm"
        placeholder={placeholder} />
    </div>
  );

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-2xl max-h-[92vh] flex flex-col">

        <div className="bg-gradient-to-r from-indigo-600 to-purple-600 text-white p-5 rounded-t-xl flex justify-between items-center flex-shrink-0">
          <div>
            <h2 className="text-xl font-bold">Générateur de fiche de poste PDF</h2>
            <p className="text-indigo-100 text-sm mt-0.5">Générez et partagez par WhatsApp ou Email</p>
          </div>
          <button onClick={onClose} className="p-1 hover:bg-white hover:bg-opacity-20 rounded-lg transition"><X className="w-5 h-5" /></button>
        </div>

        <div className="overflow-y-auto flex-1 p-5 space-y-4">
          <div className="grid grid-cols-2 gap-4">
            {f('Titre du poste','titre','Ex: Expert Exchange Hybride')}
            {f('Client','client','Ex: État de Fribourg')}
          </div>
          <div className="grid grid-cols-2 gap-4">
            {f('Responsable commercial','responsable','Ex: Domingos MUIKA')}
            {f('Date de réception','dateReception','')}
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Contenu du besoin *
              <span className="ml-2 text-xs font-normal text-gray-400">Copiez-collez l'email reçu</span>
            </label>
            <textarea value={formData.contenu} onChange={e => setFormData({...formData,contenu:e.target.value})}
              rows={12} className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-indigo-500 text-sm font-mono resize-none"
              placeholder={"MISSION PRINCIPALE\n...\n\nCOMPÉTENCES REQUISES\n- Compétence 1"} />
            {formData.contenu && <div className="text-xs text-gray-400 mt-1 text-right">{formData.contenu.length} caractères</div>}
          </div>
          <div className="bg-indigo-50 rounded-lg p-3 text-xs text-indigo-700">
            Astuce : Les lignes en MAJUSCULES ou commençant par ## seront des titres de section.
          </div>

          {pdfUrl && (
            <div className="bg-green-50 border border-green-200 rounded-xl p-4 space-y-3">
              <p className="text-xs font-semibold text-green-700">PDF hébergé — prêt à partager</p>
              <div className="flex items-center gap-2 bg-white border border-green-200 rounded-lg px-3 py-2">
                <span className="text-xs text-gray-600 truncate flex-1">{pdfUrl}</span>
                <button onClick={() => { navigator.clipboard.writeText(pdfUrl); showNotification('Lien copié !','success'); }}
                  className="text-xs text-indigo-600 hover:text-indigo-800 font-medium flex-shrink-0">Copier</button>
              </div>
              <div className="grid grid-cols-2 gap-2">
                <button onClick={shareWhatsApp}
                  className="flex items-center justify-center gap-2 py-2.5 bg-green-500 hover:bg-green-600 text-white text-sm font-medium rounded-lg transition">
                  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
                  Partager WhatsApp
                </button>
                <button onClick={shareEmail}
                  className="flex items-center justify-center gap-2 py-2.5 bg-blue-500 hover:bg-blue-600 text-white text-sm font-medium rounded-lg transition">
                  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current"><path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/></svg>
                  Envoyer Email
                </button>
              </div>
            </div>
          )}
        </div>

        <div className="flex items-center justify-between p-4 border-t border-gray-100 flex-shrink-0">
          <button onClick={onClose} className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition text-sm">Fermer</button>
          <div className="flex gap-2">
            <button onClick={handleDownload} disabled={!formData.contenu.trim() || generating || uploading}
              className="flex items-center gap-1.5 px-4 py-2 bg-gray-700 hover:bg-gray-800 text-white text-sm rounded-lg disabled:opacity-50 transition">
              {generating ? <><div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white" />...</> : <><Download className="w-4 h-4" />Télécharger</>}
            </button>
            <button onClick={handleUploadAndShare} disabled={!formData.contenu.trim() || generating || uploading}
              className="flex items-center gap-1.5 px-5 py-2 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-medium rounded-lg disabled:opacity-50 transition">
              {uploading ? <><div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white" />Upload...</> : 'Générer & Partager'}
            </button>
          </div>
        </div>

      </div>
    </div>
  );
};

export default JDGeneratorModal;
